document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('[data-sxt-delivery-date]');
  if (!targets.length) return;

  const arrival = new Date();
  arrival.setHours(12, 0, 0, 0);
  let addedBusinessDays = 0;

  while (addedBusinessDays < 4) {
    arrival.setDate(arrival.getDate() + 1);
    const day = arrival.getDay();
    if (day !== 0 && day !== 6) addedBusinessDays += 1;
  }

  const formatted = new Intl.DateTimeFormat('bg-BG', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  }).format(arrival);

  targets.forEach((target) => {
    target.textContent = formatted.charAt(0).toUpperCase() + formatted.slice(1);
  });
});
